import cn from "classnames";

/** Shared base styles for primary/secondary pill buttons. */
export const BUTTON_BASE_CLASS =
  "flex items-center justify-center gap-2 rounded-full font-bold uppercase duration-300 disabled:pointer-events-none disabled:select-none";

/**
 * Hero CTA color variants (Blu cyan on dark hero panels).
 * Layout, size, and font remain controlled by the consuming component.
 */
export const heroPrimaryButtonClassName = cn(
  "border border-transparent bg-primary text-secondary",
  "hover:bg-primary-400 hover:text-secondary",
  "active:bg-primary-200 active:text-secondary",
  "focus-visible:bg-primary focus-visible:text-secondary focus-visible:border-[3px] focus-visible:border-white focus-visible:outline-none",
  "disabled:bg-primary-200 disabled:text-white",
);

export const heroSecondaryButtonClassName = cn(
  "border-2 border-primary bg-transparent text-white",
  "hover:border-primary-400 hover:bg-transparent hover:text-primary-400",
  // Active fills with primary-200; text uses secondary navy for contrast on that fill
  // (spec listed #92E6FF for text, which would match the background and be unreadable).
  "active:border-[3px] active:border-primary-200 active:bg-primary-200 active:text-secondary",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white",
  "disabled:pointer-events-none disabled:opacity-60",
);

export type ButtonVariant = "heroPrimary" | "heroSecondary";

export const buttonVariantClassName = (
  variant?: ButtonVariant | null,
): string | undefined => {
  if (variant === "heroPrimary") return heroPrimaryButtonClassName;
  if (variant === "heroSecondary") return heroSecondaryButtonClassName;
  return undefined;
};
